import CashrentFooter from "./CashrentFooter";

export default CashrentFooter;
